// =============================================
// NODE: SET VARIABLES (DEFINIR MULTIPLAS VARIAVEIS)
// =============================================
// Arquivo: SetVariablesNode.tsx
// Descrição: No para definir multiplas variaveis de uma vez
// Similar ao Set do n8n - permite atribuir valores a variaveis
// =============================================

import React from 'react';
import { Handle, Position } from 'reactflow';
import ActionsBadge from './ActionsBadge';
import './NodeStyles.css';

interface VariableAssignment {
  id: string;
  name: string;
  value: string;
  type?: 'string' | 'number' | 'boolean' | 'json' | 'expression';
}

interface SetVariablesNodeProps {
  data: {
    label?: string;
    assignments?: VariableAssignment[];
    keepOnlySet?: boolean;
    actions?: {
      input?: any[];
      output?: any[];
    };
  };
  selected?: boolean;
}

const SetVariablesNode: React.FC<SetVariablesNodeProps> = ({ data, selected }) => {
  const assignments = data.assignments || [];

  return (
    <div className={`custom-node set-variables-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        id="set-input"
        className="node-handle target-handle"
      />

      <div className="node-icon">
        <i className="fas fa-edit"></i>
      </div>

      <div className="node-content">
        <div className="node-label">{data.label || 'Definir Variaveis'}</div>

        {assignments.length > 0 && (
          <div className="node-preview">
            <i className="fas fa-list-ul"></i>
            <span>{assignments.length} variavel{assignments.length > 1 ? 'is' : ''}</span>
          </div>
        )}

        {assignments.slice(0, 3).map((assignment, index) => (
          <div key={assignment.id || index} className="node-preview variable-preview">
            <i className="fas fa-equals"></i>
            <span className="variable-name">{assignment.name}</span>
            <span className="variable-separator">=</span>
            <span className="variable-value">
              {String(assignment.value).substring(0, 15)}
              {String(assignment.value).length > 15 ? '...' : ''}
            </span>
          </div>
        ))}

        {assignments.length > 3 && (
          <div className="node-preview more-variables">
            <span>+{assignments.length - 3} mais...</span>
          </div>
        )}

        <ActionsBadge actions={data.actions} />
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        id="set-output"
        className="node-handle source-handle"
      />
    </div>
  );
};

export default SetVariablesNode;
